import { PatientSummaryDto } from '../../../../api/generated/model';
import { TooltipCell } from '../../../../components/table/TooltipCell.tsx';
import { formatDate } from '../../../../utils/date.ts';

export function PatientTablePatientInfosHeader({ showCreatedAt = true }: { showCreatedAt?: boolean }) {
  return (
    <>
      <th style={{ width: 160, minWidth: 160 }}>Name</th>
      <th style={{ width: 160, minWidth: 160 }}>Vorname</th>
      <th style={{ width: 125, minWidth: 125 }}>Geb.</th>
      {showCreatedAt && <th style={{ width: 125, minWidth: 125 }}>Erfasst am</th>}
    </>
  );
}

export function PatientTablePatientInfosData({
  patient,
  showCreatedAt = true,
}: {
  patient: PatientSummaryDto;
  showCreatedAt?: boolean;
}) {
  return (
    <>
      <TooltipCell>{patient.firstName}</TooltipCell>
      <TooltipCell>{patient.lastName}</TooltipCell>
      <td>{formatDate(patient.birthDate)}</td>
      {showCreatedAt && <td>{formatDate(patient.patientCreated)}</td>}
    </>
  );
}
